import React from 'react';
import ReactDOM from 'react-dom';
import Auth from './auth';
import QRscan from './qrscan';

// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

import './scss/style.scss'

var search = location.search.substring(1);
if(search) var json = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

if(json != undefined && json.qrscanner != undefined) {
 ReactDOM.render(<QRscan {...json} token={json.qrscanner} />, document.getElementById('root'));
} else {
 ReactDOM.render(<Auth />, document.getElementById('root'));
}



// WEBPACK FOOTER //
// ./websources/index.js